import InputTypes from 'utils/enums/inputTypes';
import { IField } from 'utils/interfaces/IField';

const contests: IField[] = [
    {
        presentation: 'Nome',
        label: 'Nome da marca',
        name: 'name',
        type: InputTypes.text,
        columns: 3
    }
];

export default contests;
